import { useNavigate } from 'react-router-dom';

function PaymentHeader({ voucherNo, onPrintVoucher }) {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-3">
        <button
          onClick={() => {
            sessionStorage.removeItem('purchase_payment_state');
            navigate('/purchase/invoices');
          }}
          className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-[#e2e8f0] text-slate-500 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-line" />
        </button>
        <div>
          <h1 className="text-xl font-bold text-[#1e293b]">Available Dues</h1>
          <p className="text-xs text-slate-400">{voucherNo}</p>
        </div>
      </div>
      {voucherNo && voucherNo !== '—' && (
        <button
          onClick={() => onPrintVoucher?.(voucherNo)}
          className="flex items-center gap-2 h-9 px-3 rounded-lg border border-[#e2e8f0] text-sm font-medium text-slate-600 hover:bg-slate-50 transition-colors cursor-pointer"
          title="Print Voucher"
        >
          <i className="ri-printer-line" /> Print Voucher
        </button>
      )}
    </div>
  );
}

export default PaymentHeader;
